<template>
    <el-dialog
       title="지정 예약"
       :visible="DialogVisible"
       :append-to-body="true"
       :show-close="true"
       custom-class="fifl-dialog target-booking-dialog__container"
       :close-on-press-escape="false"
       :close-on-click-modal="true"
       @close="closeDialog"  
    >
    <h1 id="target-booking-dialog__comment">본 수업 예약 시 이용할 <strong>{{ memberName }}</strong> 님의 회원권을 선택해주세요. 선택된 회원권에서 횟수가 차감됩니다.</h1>
    <section class="target-booking-dialog__select-wrapper">
        <article v-if="!selectedMembership">
            <h3 class="placeholder">회원권을 선택해주세요</h3>
        </article>
        <article v-else>
            <h3 class="membership-name__selected">{{ selectedMembership.parent_membership.name }}</h3>
            <p class="date-range__selected">{{ format(selectedMembership.start,"YYYY.MM.DD") }} ~ {{ format(selectedMembership.end,"YYYY.MM.DD") }}</p>
        </article>
        <el-select
          value=""
          placeholder=""
          class="target-booking-dialog__select"       
          :popper-append-to-body="false"
          @change="handleMemebershipChange"
        > 
            <el-option
              v-for="membership in memberships"
              :key="membership.id"
              :value="membership.id"
              :label="membership.parent_membership.name"        
            >        
                <div class="target-booking-dialog__select-option">
                    <p class="membership-name">{{ membership.parent_membership.name }}</p>
                    <p class="date-range">{{ format(membership.start,"YYYY.MM.DD") }} ~ {{ format(membership.end,"YYYY.MM.DD") }}</p>
                    <section class="checked-area">
                        <i class="el-icon-check" />
                    </section>
                </div>
            </el-option>    
        </el-select>
    </section>
    <dialog-action-buttons
      ref="dialogActionButtons"
      slot="footer"
      cancel-label="취소"
      confirm-label="확인"
      @cancel="closeDialog"
      @confirm="handleTargetBookingComplete" 
    />
    </el-dialog>  
</template>

<script>
import { format } from "date-fns";
import DialogActionButtons from "@/components/dialogActionButtons";

export default {
    name:'TargetBookingDialog',
    components : { DialogActionButtons },
    props:{
        isTargetBookingDialogVisible : {
            type : Boolean,
            default : false
        },
        memberName : {
            type : String,
            default : "회원1"
        },
        memberships : {
            type : Array,
            default: []
        }
    },
    data(){
        return {
            selectedMembership : null,
        }
    },
    computed : {
        DialogVisible(){   
            return this.isTargetBookingDialogVisible
        }
    },
    methods:{
        format,
        closeDialog : function(){
            this.$emit('close');
            this.selectedMembership = null;
        },
        handleTargetBookingComplete(){
            if(this.selectedMembership){
                this.$emit('complete', this.selectedMembership);
            }else{
                this.$emit('complete', null);
            }
            this.$refs['dialogActionButtons'].stopLoading();
        },
        handleMemebershipChange(id){       
            for(let membership of this.memberships){
                if(membership.id === id){
                    this.selectedMembership = membership;
                }
            }
        },
    }
}
</script>

<style lang="scss">
    #target-booking-dialog__comment{
        width: 100%;
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.5px;
        color: #545454;
        margin-bottom: 15px;
        word-break: keep-all;
    }
    .target-booking-dialog__container .el-select {
        width: 100%;
        margin-bottom: 25px;
    }
    .target-booking-dialog__select-wrapper{
        position : relative;
        article{
            position: absolute;
            cursor: pointer;
            display : flex;
            top:1px;
            left:1px;
            padding: 0 30px 0 15px; 
            width: calc(100% - 1px);
            height: 38px;
            box-sizing: border-box;
            background-color: #ffffff;
            border-radius: 4px;
            h3{
                white-space: nowrap;
                font-size: 15px;
                margin : 0;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 40px;
                letter-spacing: -0.8px;
            }
            .placeholder {
                color: #b9b9b9;                
                width: 100%;
            }
            .membership-name__selected,
            .date-range__selected{
                color : #4a4a4a;
            }
            .membership-name__selected{
                width: calc(100% - 135px);
                overflow: hidden;
                text-overflow: ellipsis;
                @media screen and (max-width: 768px){
                    width: calc(100% - 120px);
                }
            }
            .date-range__selected{
                width: 130px;
                font-size: 12px;
                line-height: 40px;
                letter-spacing: -0.8px;
                margin: 0;
                margin-left: 5px;
                @media screen and (max-width: 768px){
                    width: 120px;
                    font-size: 11.5px;
                }
            }
            
        }
    }

    .target-booking-dialog__container .target-booking-dialog__select{
        .el-input__inner{
            background-color : transparent;
            overflow: hidden;
            text-overflow: ellipsis;            
        }
    }
    .target-booking-dialog__container .el-popper{
        margin-top: 6px !important;
        width: 495px;
        z-index: 1999 !important;
        @media screen and (max-width: 768px){
            width: calc(100% - 80px) !important;
        }
        .el-scrollbar__wrap{
            @media screen and (max-width: 768px){
                overflow: hidden;
                width: 100%;
                margin: 0 !important;
        }
        }
        .el-select-dropdown__item.selected{
             .checked-area{
                position: relative;
                visibility: visible !important;
                width: 20px;
                height: 20px;
                margin: 0;
                display: flex;
                i{
                    height: 14px;
                    margin: auto;
                }
            }
        }

        .el-select-dropdown__item{
            font-size: 14px;
            font-weight: 400;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: -0.8px;
            height: initial;
            padding:0;
        }
        .target-booking-dialog__select-option{
            width: calc(100% - 20px);
            padding: 8px 5px 8px 15px;
            height: 20px;
            display: flex;
            p{
                margin: auto;
            }
            .membership-name{
                font-size: 14px;
                line-height: 14px;
                width: calc(100% - 110px - 35px - 20px);
                overflow: hidden;
                text-overflow: ellipsis;
                margin-left: 0;
                @media screen and (max-width: 768px){
                    width: calc(100% - 105px - 10px - 20px);
                }
            }
            .date-range{
                width: 110px;
                margin-left: 5px;
                margin-right: 0;
                font-size: 12px;
                line-height: 12px;
                letter-spacing: -0.8px;
                @media screen and (max-width: 768px){
                    width: 105px;
                    font-size: 11.5px;
                    line-height: 11.5px;
                }
            }
            .checked-area{
                visibility: hidden;
                position: relative;
                width: 20px;
                height: 20px;
                margin: 0;
            }
        }
    }
    .target-booking-dialog__container .popper__arrow{
        display: none !important;
    }
</style>